import React from 'react';

const MarketingChartIcon = ({ fill = "#717680", width = "24", height = "24" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path d="M3 21V8m6 13V3m6 18v-7m6 7V11" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
};

export default MarketingChartIcon;
